import { Controller } from "@hotwired/stimulus";
import { toastManager } from "../components/DownloadTray/ToastManager";

// GR-3390: a flash message that has to survive a turbo-frame response.
//
// A frame response renders the frame and nothing else, so the layout — and
// with it `layouts/shared/_toasts` and the toast manager it mounts — is never
// part of the answer. Anything the server wants to say about a frame-scoped
// action therefore has to ride inside the frame.
//
// So the frame renders this hook carrying the message, and the hook hands it
// to the toast manager the page already has mounted from its first full
// render. It then takes itself out of the DOM: the frame re-renders on every
// add, remove and search, and an element left in it would replay a stale
// message on the next one.
export default class extends Controller {
  static values = { message: String, variant: String, icon: String };

  connect() {
    if (!this.messageValue) return;

    toastManager.show({
      message: this.messageValue,
      variant: this.variantValue || "success",
      icon: this.iconValue || "check",
      autoCloseMs: 6000,
    });

    this.element.remove();
  }
}
